import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Home from "@/pages/Home";
import Enquire from "@/pages/Enquire";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import Gallery from "@/pages/Gallery";
import Landing from "@/pages/Landing";
import Church from "@/pages/Church";
import Fields from "@/pages/Fields";
import MusicRoom from "@/pages/MusicRoom";
import Garden from "@/pages/Garden";
import NotFound from "@/pages/NotFound";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App bg-parchment-noise min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/house" element={<Home />} />
          <Route path="/manor" element={<Navigate to="/house" replace />} />
          <Route path="/music-room" element={<MusicRoom />} />
          <Route path="/garden" element={<Garden />} />
          <Route path="/church" element={<Church />} />
          <Route path="/fields" element={<Fields />} />
          <Route path="/enquire" element={<Enquire />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/diary" element={<BlogIndex />} />
          <Route path="/diary/:slug" element={<BlogPost />} />
          <Route path="/journal" element={<BlogIndex />} />
          <Route path="/journal/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
